import store from '../../store';
import allActions from '../../store/actions';

const handleEditClick = (step) => {
  store.dispatch(allActions.formConfigActions.setBackFromSummary(true));
  store.dispatch(allActions.formConfigActions.setFormStep(step));
};

export { handleEditClick };
